var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Maintenance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-Maintenance",
    transform: "translate(-87.000000, -489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(87.000000, 489.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.4774,0 0,4.4774 0,10 C0,15.5226 4.4774,20 10,20 C15.5226,20 20,15.5226 20,10 C20,4.4774 15.5226,0 10,0 Z",
    id: "Path",
    fill: "#D5D8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0726,15.1414 L6.9272,15.1414 C6.27798,15.1414 5.7522,14.61562 5.7522,13.9664 L5.7522,10.1718 C5.7522,9.6054 6.15298,9.13274 6.6858,9.0218 L6.6858,7.30852 C6.6858,5.48118 8.17252,3.99452 9.9998,3.99452 C11.82708,3.99452 13.3138,5.48124 13.3138,7.30852 L13.3138,9.0218 C13.84662,9.133518 14.2474,9.6054 14.2474,10.1718 L14.2474,13.9664 C14.2474,14.61562 13.72162,15.1414 13.0724,15.1414 L13.0726,15.1414 Z",
    id: "Path",
    fill: "#8B91A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,10.7656 C9.42578,10.7656 8.96016,11.23122 8.96016,11.80544 C8.96016,12.1906 9.17032,12.52576 9.48126,12.70544 L9.48126,13.86168 L10.51876,13.86168 L10.51876,12.70544 C10.8297,12.525752 11.03986,12.18982 11.03986,11.80544 C11.03986,11.23122 10.57424,10.7656 10.00002,10.7656 L10,10.7656 Z",
    id: "Fill-1",
    fill: "#D5D8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,5.7234 C9.12578,5.7234 8.41484,6.43434 8.41484,7.30856 L8.41484,8.99684 L11.5844406,8.99684 L11.5844406,7.30856 C11.585222,6.43434 10.87428,5.7234 10.00006,5.7234 L10,5.7234 Z",
    id: "Fill-2",
    fill: "#D5D8E1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.ce85f4dc170006a1831ca838d4a5c767.svg";
export { ForwardRef as ReactComponent };